import { Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  QBox,
  QFormControl,
  QRadio,
  QRadioGroup,
  QStack,
  QText,
} from '@qualio/ui-components';

import { Question } from '../../../../TrainingAssessment/types/trainingAssessment';

export const TrainingAssessmentQuestion = ({
  question,
  index,
  control,
  hasWrongAnswer,
  'data-cy': dataCy,
}: {
  question: Question;
  index: number;
  control: Control;
  hasWrongAnswer?: boolean;
  'data-cy'?: string;
}) => {
  const { t } = useTranslation();
  return (
    <QBox
      data-cy={dataCy}
      p={4}
      border={`${hasWrongAnswer ? 2 : 1}px solid`}
      borderColor={hasWrongAnswer ? 'red.400' : 'gray.100'}
      borderRadius={3}
    >
      <QStack spacing={7}>
        <QText weight="semibold">
          {t('trainingAssessment.questionNumber', { number: index })}
        </QText>
        <QStack spacing={4}>
          <QText weight="semibold">{`${question.question}`}</QText>
          <Controller
            name={`question-${index}`}
            control={control}
            render={({ field: { onChange, value } }) => {
              return (
                <QRadioGroup onChange={onChange} value={value}>
                  <QStack spacing={4}>
                    {question.answers.map((answer, idx) => {
                      return (
                        <QFormControl key={`answer-${idx}`}>
                          <QRadio value={String(idx)}>{answer.answer}</QRadio>
                        </QFormControl>
                      );
                    })}
                  </QStack>
                </QRadioGroup>
              );
            }}
          />
        </QStack>
      </QStack>
    </QBox>
  );
};
